export default __webpack_public_path__ + "static/media/custom4.61db7467.png";